/**
 * Created with IntelliJ IDEA.
 * User: ihahn
 * Date: 15.03.13
 * Time: 08:41
 * To change this template use File | Settings | File Templates.
 */
import { NoneValueSignal } from "../../signal/NoneValueSignal";
import { ObjectSignal } from "../../signal/ObjectSignal";
import { getQualifiedClassName } from "@goodgamestudios/createjs-utilities";

import DisplayObject = createjs.DisplayObject;
import MouseEvent = createjs.MouseEvent;

export class AComboBoxItem {
    private _disp: DisplayObject;
    private _selected: boolean;
    private _listItemClickSignal: ObjectSignal;
    private _selectedItemClickSignal: NoneValueSignal;
    private _className: string;

    protected _itemClass: any; // set this when extending this class!
    protected clickFunction: Function;
    protected clickFunctionParams: any[];

    /**
     * Constructor.
     *
     * Creates the ComboBoxItem that represent a list entry either selected or not.
     */
    constructor() {
        this._selectedItemClickSignal = new NoneValueSignal();
        this._listItemClickSignal = new ObjectSignal();
        // @HTML5 flash.utils.getQualifiedClassName is missing, setting className to null
        this._className = getQualifiedClassName(this);
    }

    /**
     * Defines the DisplayObject for this item.
     *
     * @param disp The DisplayObject that will be used
     * @return The DisplayObject that will be used.
     */
    public createAsset(disp: DisplayObject): DisplayObject {
        this._disp = disp;
        this._disp.addEventListener("click", this.bindFunction(this.onItemMouseClick));
        this._disp.addEventListener("mouseover", this.bindFunction(this.onMouseOver));
        this._disp.addEventListener("mouseout", this.bindFunction(this.onMouseOut));
        this._disp.addEventListener("mousedown", this.bindFunction(this.onMouseDown));
        this._disp.addEventListener("pressmove", this.bindFunction(this.onPressMove));

        return this._disp;
    }

    /**
     * Sets the clickFunction for this item.
     *
     * @param func
     * @param args
     */
    public setClickFunction(func: Function, args: any[] = null): void {
        this.clickFunction = func;
        this.clickFunctionParams = args;
    }

    /**
     * Click Event Handler for this item.
     * Will dispatch the click signal and call the corresponding click function with or without parameters.
     *
     * @param event
     */
    protected onItemMouseClick(event: MouseEvent): void {
        if (!this.selected) {
            this._listItemClickSignal.signal(this);

            if (this.clickFunction != null) {
                if (this.clickFunctionParams) {
                    this.clickFunction.apply(this, this.clickFunctionParams);
                }
                else {
                    this.clickFunction.call(this);
                }
            }
        }
        else {
            this._selectedItemClickSignal.signal();
        }
    }

    protected onMouseOver(event: MouseEvent): void {

    }

    protected onMouseOut(event: MouseEvent): void {

    }

    protected onMouseDown(event: MouseEvent): void {

    }

    protected onPressMove(event: MouseEvent): void {

    }

    /**
     * Destroy function that will remove all signals and internal mouse event handlers.
     */
    public destroy(): void {
        this._disp.removeEventListener("click", this.bindFunction(this.onItemMouseClick));
        this._disp.removeEventListener("mouseover", this.bindFunction(this.onMouseOver));
        this._disp.removeEventListener("mouseout", this.bindFunction(this.onMouseOut));
        this._disp.removeEventListener("mousedown", this.bindFunction(this.onMouseDown));
        this._disp.removeEventListener("pressmove", this.bindFunction(this.onPressMove));

        this._selectedItemClickSignal.removeAll();
        this._listItemClickSignal.removeAll();
    }

    public set x(value: number) {
        this._disp.x = value;
    }

    public get x(): number {
        return this._disp.x;
    }

    public get y(): number {
        return this._disp.y;
    }

    public set y(value: number) {
        this._disp.y = value;
    }

    public set width(value: number) {
        this._disp.width = value;
    }

    public get width(): number {
        return this._disp.width;
    }

    public set height(value: number) {
        this._disp.height = value;
    }

    public get height(): number {
        return this._disp.height;
    }

    public get selected(): boolean {
        return this._selected;
    }

    public select(): void {
        this._selected = true;
    }

    public get listItemClickSignal(): ObjectSignal {
        return this._listItemClickSignal;
    }

    public get disp(): DisplayObject {
        return this._disp;
    }

    public get selectedItemClickSignal(): NoneValueSignal {
        return this._selectedItemClickSignal;
    }

    public get itemClass(): any {
        return this._itemClass;
    }

    public get className(): string{
        return this._className;
    }
}
